var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96959 3.96725C4.11024 3.82664 4.30097 3.74766 4.49984 3.74766C4.69871 3.74766 4.88945 3.82664 5.03009 3.96725L8.99982 7.937L12.9696 3.96725C13.0388 3.89561 13.1215 3.83848 13.213 3.79917C13.3045 3.75986 13.403 3.73918 13.5025 3.73831C13.6021 3.73745 13.7009 3.75642 13.7931 3.79413C13.8852 3.83184 13.9689 3.88754 14.0394 3.95795C14.1098 4.02837 14.1655 4.11211 14.2032 4.20428C14.2409 4.29646 14.2599 4.39522 14.259 4.4948C14.2581 4.59439 14.2374 4.6928 14.1981 4.7843C14.1588 4.8758 14.1017 4.95857 14.0301 5.02775L10.0603 8.9975L14.0301 12.9672C14.1667 13.1087 14.2423 13.2981 14.2406 13.4948C14.2389 13.6914 14.16 13.8795 14.0209 14.0186C13.8819 14.1576 13.6938 14.2365 13.4971 14.2383C13.3005 14.24 13.111 14.1644 12.9696 14.0278L8.99982 10.058L5.03009 14.0278C4.88864 14.1644 4.69919 14.24 4.50254 14.2383C4.30589 14.2365 4.11779 14.1576 3.97873 14.0186C3.83967 13.8795 3.76079 13.6914 3.75909 13.4948C3.75738 13.2981 3.83297 13.1087 3.96959 12.9672L7.93932 8.9975L3.96959 5.02775C3.82899 4.88711 3.75 4.69637 3.75 4.4975C3.75 4.29863 3.82899 4.10789 3.96959 3.96725Z",
    fill: "black",
    fillOpacity: 0.58
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.0fc227c3796686e8b893c341f8ed98bb.svg";
export { ForwardRef as ReactComponent };